module.exports = __webpack_public_path__ + "img/15.be05cb09.jpg";